export default function StoreCn({ prefixCls, locale }: { prefixCls: string; locale: string }) {
    return <>StoreCn</>;
}
